export default __webpack_public_path__ + "static/media/assail.e93050c3.png";